/**
 * 0.36.657 — Server-source eligibility check for library-backed
 * form elements. 0.36.658 — Cascade (filter_by_element) now
 * eligible. 0.36.659 — Multi-column labels (label_columns.length > 1)
 * now eligible — HenaketDropdown / MultiDropdown build the joined
 * label client-side and forward the config to /hydrate.
 *
 * 0.38.41 — `include_values` (introduced in 0.38.36 for the
 * LibraryRowSelector) now disqualifies. HenaketDropdown's server-
 * source path fetches rows via /rows without knowing about the
 * include filter, so admin-picked rows were ignored on the public
 * form even though `include_values` was correctly stored. Client-
 * side path (resolveElementOptions) is what applies the include
 * filter, and rerouting there when include_values is set is the
 * fix. Same shape as the exclude_values disqualifier below.
 *
 * Return true iff a library-backed dropdown/multiselect element
 * can safely use the HenaketDropdown/MultiDropdown `serverSource`
 * prop instead of the full-materialization path.
 *
 * Ineligible if any of:
 *
 *   - `extra_options` non-empty          extras must merge client-side
 *   - `exclude_values` non-empty         client-side row exclusion
 *   - `include_values` set (any length)  client-side row inclusion
 *                                        filter — empty [] means
 *                                        "include none" which also
 *                                        needs the client path
 *   - `sort` set to 'asc' or 'desc'      client-side sort; server
 *                                        support deferred
 *   - Rule-added options for this name   dynamic add_option effect
 *   - Rule-set sort order                dynamic set_sort_order
 */
import { removedOptionValues } from '../lib/resolveElementOptions';

export function isServerSourceEligible(e, ruleState) {
  if (!e) return false;
  if (e.source !== 'library' || !e.library) return false;
  if (e.type !== 'dropdown' && e.type !== 'multiselect') return false;
  if (Array.isArray(e.extra_options) && e.extra_options.length > 0) return false;
  if (Array.isArray(e.exclude_values) && e.exclude_values.length > 0) return false;
  // 0.38.41 - Any include_values array disqualifies. Empty array
  // means "include none" (per 0.38.37 semantics) - the server-source
  // path has no way to express that; missing/undefined field remains
  // eligible (=include all, no filter needed).
  if (Array.isArray(e.include_values)) return false;
  // 0.49.50 - The newer, key-based form too.
  if (Array.isArray(e.include_rows)) return false;
  if (e.sort && e.sort !== 'none') return false;
  // 0.47.74 - A filter other than "equals" (does not equal, a number
  // comparison) is applied on the client: the server's /rows filter
  // only matches equal values.
  if (e.filter_by_element && e.filter_op && e.filter_op !== 'equals') return false;
  if (ruleState && ruleState.addedOptions && e.name) {
    const arr = ruleState.addedOptions.get(e.name);
    if (Array.isArray(arr) && arr.length > 0) return false;
  }
  // 0.49.82 - Values a remove_option rule leaves out are filtered here.
  if (removedOptionValues(ruleState, e.name)) return false;
  if (ruleState && ruleState.sortOrder && e.name) {
    const s = ruleState.sortOrder.get(e.name);
    if (s === 'asc' || s === 'desc') return false;
  }
  return true;
}
